import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Let the authenticated boot request finish before a newly-installed worker claims
// the page. This also avoids a first-launch race where the shell is ready before
// Safari has resolved the current private profile.
if ('serviceWorker' in navigator) window.addEventListener('load', () => {
  window.setTimeout(() => navigator.serviceWorker.register('/sw.js').catch(console.error), 1_500);
});

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
